const CAROUSEL_ITEMS = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=Entertainment%20industry%20breaking%20news%20concept%2C%20dramatic%20warm%20lighting%2C%20spotlight%20on%20stage%2C%20abstract%20newspaper%20headlines%2C%20editorial%20photography%20style%2C%20coral%20and%20amber%20tones&width=600&height=400&seq=carousel-01&orientation=landscape',
    title: '顶流明星恋情实锤：独家追踪报道',
    desc: '多角度实锤证据完整梳理，时间线+照片+知情人士爆料，全网最全整理。持续更新中，建议收藏关注。',
    tag: '明星八卦',
    badge: '🔥 热议',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Social%20media%20influencer%20controversy%20concept%2C%20trending%20topic%20visualization%2C%20dramatic%20warm%20lighting%2C%20digital%20media%20aesthetic%2C%20coral%20tones&width=600&height=400&seq=carousel-02&orientation=landscape',
    title: '千万网红翻车合集：从顶流到塌房',
    desc: '盘点近期翻车的头部网红，从虚假人设到商业欺诈，完整还原塌房全过程，带你认清网红真面目。',
    tag: '网红翻车',
    badge: '💥 爆款',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20TV%20variety%20show%2C%20mysterious%20atmosphere%2C%20dramatic%20lighting%2C%20entertainment%20industry%20secrets%2C%20warm%20amber%20and%20coral%20tones&width=600&height=400&seq=carousel-03&orientation=landscape',
    title: '综艺幕后大揭秘：剪辑师的爆料',
    desc: '多位综艺剪辑师匿名爆料行业内幕，剧本安排、人设包装、恶意剪辑……你看的综艺到底有多少是真的？',
    tag: '综艺内幕',
    badge: '🎬 独家',
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=Social%20media%20viral%20content%20explosion%20concept%2C%20abstract%20network%20visualization%2C%20trending%20hashtags%2C%20warm%20gradient%20colors%2C%20modern%20digital%20art%20style&width=600&height=400&seq=carousel-04&orientation=landscape',
    title: '2024娱乐圈大事件年终盘点',
    desc: '年度最全盘点！从年初到年末，娱乐圈、网红圈、直播圈所有重磅事件一次性回顾，看看你错过了哪些瓜。',
    tag: '年度盘点',
    badge: '📋 专题',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full mb-4 whitespace-nowrap">
            专题报道
          </span>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
            焦点专题
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {CAROUSEL_ITEMS.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200/60 transition-all duration-300 flex flex-col"
            >
              <div className="relative overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full aspect-[3/2] object-cover group-hover:scale-105 transition-transform duration-500"
                  width="600"
                  height="400"
                />
                <span className="absolute top-3 left-3 text-[11px] px-2.5 py-1 rounded-full bg-background-50/90 text-foreground-700 font-medium whitespace-nowrap">
                  {item.tag}
                </span>
                <span className="absolute top-3 right-3 text-[11px] px-2 py-1 rounded-full bg-primary-500 text-background-50 font-semibold whitespace-nowrap">
                  {item.badge}
                </span>
              </div>
              <div className="p-4 flex flex-col gap-2 flex-1">
                <h3 className="text-sm font-bold text-foreground-900 leading-snug line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-3 flex-1">
                  {item.desc}
                </p>
                <span className="whitespace-nowrap inline-flex items-center gap-1 text-xs font-medium text-primary-500 mt-1 cursor-pointer">
                  查看详情 <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}